import axios from "axios";
import authHeader from '../../../authheader'

const PLSRENEWALURL = process.env.REACT_APP_APIURL + "/api/IndividualPlsRenewal";

const getViolation = (renewalId) => {
    return axios.get(`${PLSRENEWALURL}/violation`, { headers: authHeader(), params: { renewalId } });
}
const postViolation = (data) => {
    return axios.post(`${PLSRENEWALURL}/violation`, data, { headers: authHeader() });
}
export default {
    getViolation,
    postViolation
}